export default function (notes, discrepancies, lockedDiscrepancyId, addNote, $state, toaster, close, $stateParams) {
    const vm = this;

    vm.model = { };
    vm.form = null;
    vm.save = add;
    vm.closeModal = close;
    vm.discrepancies = discrepancies;
    vm.canUpdateDiscrepancy = true;
    vm.canUpdateSubject = true;

    /* --- */

    if (lockedDiscrepancyId !== null) {
        vm.canUpdateSubject = false;
        vm.canUpdateDiscrepancy = false;

        vm.model.subject = '200';
        vm.model.discrepancyId = lockedDiscrepancyId;
    }

    /* --- */

    function add() {
        if (vm.form.$invalid) {
            return;
        }

        vm.model.vehicleId = $stateParams.vehicleId;
        if (vm.model.attachment) {
            vm.model.ContentType = vm.model.attachment.type;
            vm.model.FileName = vm.model.attachment.name;
        }

        addNote(vm.model).then(returnData => {
            toaster.pop('success', 'The note has been submitted.  If it had an attachment, please refresh the page later to view it.');
            // Add the note to the model so that it becomes visible
            notes.push(returnData.data);
            close();
        })
        .catch(error => {
            toaster.pop('error', error.data);
        });
    }
}



// WEBPACK FOOTER //
// ./Client/app/tasks/controllers/notes/add/addNoteCtrl.js